import { Component, inject } from '@angular/core';
import { Category } from '../category/category';
import { Router } from '@angular/router';
import { ProductCategory } from '../../models/product-category';

@Component({
  selector: 'app-shop-by-category',
  imports: [Category],
  templateUrl: './shop-by-category.html',
  styleUrl: './shop-by-category.scss'
})
export class ShopByCategory {
  private router = inject(Router);
  categories = [ProductCategory.CAPS, ProductCategory.TSHIRTS, ProductCategory.BOTTLES, ProductCategory.MUGS, ProductCategory.RESINKEYCHAIN, ProductCategory.TRENDINGPRODUCTS];

  goToCategory(name: string) {
    this.router.navigate(['/products'], {
      queryParams: { category: name }
    });
  }
}
